export default __webpack_public_path__ + "images/product-placeholder.ca50564a0e44f07e0f92600375b7bcb1.png";